import { render } from "./Slot.vue?vue&type=template&id=00bcfd50&scoped=true"
import script from "./Slot.vue?vue&type=script&lang=js"
export * from "./Slot.vue?vue&type=script&lang=js"

import "./Slot.vue?vue&type=style&index=0&id=00bcfd50&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00bcfd50"]])

export default __exports__